import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { MenuService } from '../menu.service';
import { SharedService } from '../shared.service';

const BANNERS_HISTORICOS: { [nombre: string]: string } = {
  'Limpieza': 'storage/images/web_bnncategoria-limpieza.webp',
  'Bazar': 'storage/images/web_bnncategoria-bazar.webp',
  'Textil': 'storage/images/web_bnncategoria-textil.webp',
  'Liquidos': 'storage/images/web_bnncategoria-liquidos.webp',
  'Jardin y riego': 'storage/images/web_bnncategoria-jardinyriego.webp',
  'Profesional': 'storage/images/web_bnncategoria-profesional.webp',
  'Mas productos': 'storage/images/web_bnncategoria-+productos.webp',
};

@Component({
  selector: 'app-categorias',
  templateUrl: './categorias.component.html',
  styleUrls: ['./categorias.component.scss']
})
export class CategoriasComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  environment: any;
  familias: any[] = [];

  constructor(private data: SharedService, private menu: MenuService) {
    this.environment = environment;
  }

  ngOnInit() {
    this.data.updatePageTitle('Productos de limpieza por mayor, fabrica de productos de limpieza');
    this.menu.LinkList$.pipe(takeUntil(this.destroy$)).subscribe((familias) => {
      this.familias = familias || [];
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
  }

  banner(familia: any): string {
    const historico = BANNERS_HISTORICOS[familia.texto];
    if (historico) {
      return this.environment.APP_API_BASE + historico;
    }
    return familia.url_imagen || '';
  }
}
